<template>
  <div>
    <div class="class-item" :class="[classItem.largeScreenChecked ? 'active-item' : '']" v-if="classItem.liveId">
      <a-icon v-if="classItem.largeScreenChecked" class="active-icon" type="check" />
      <div class="class-title">{{ classItem.liveName }}</div>
      <div class="class-info">
        <div class="classroom">{{ classItem.classroomName }}</div>
        <div class="time-and-rechoose">
          <div class="time">
            {{ $tools.formatDate(classItem.startTime, 'HH:mm') }}-{{ $tools.formatDate(classItem.endTime, 'HH:mm') }}
          </div>
          <div class="choose-btn" @click="openSelectDialog(classItem)">重选</div>
        </div>
      </div>
    </div>
    <div class="class-item-empty" :class="[classItem.largeScreenChecked ? 'active-item' : '']" v-else>
      <a-icon v-if="classItem.largeScreenChecked" class="active-icon" type="check" />
      <div class="choose-btn" @click="openSelectDialog(classItem)">重选</div>
    </div>
    <ReselectDialogVue
      :showSelectDialogProp.sync="showReselectDialog"
      @closeReselectdialog="closeReselectdialog"
      :screenFilter="screenFilter"
      :currentScreenItem="currentScreenItem"
      :reselectList="reselectList"
      :panoramaClassroomCode="panoramaClassroomCode"
      @updateLiveList="updateLiveList"
    />
  </div>
</template>

<script>
import ReselectDialogVue from './reselectDialog.vue'

export default {
  name: 'DataScreen',
  components: {
    ReselectDialogVue
  },
  props: {
    classItem: {
      type: Object,
      default: null
    },
    screenFilter: {
      type: Object
    },
    currentIndex: {
      type: Number
    },
    panoramaClassroomCode: {
      type: String | Number
    }
  },
  data() {
    return {
      showReselectDialog: false,
      currentScreenItem: null,
      reselectList: []
    }
  },
  methods: {
    openSelectDialog(item) {
      this.currentScreenItem = item
      console.log('item', this.screenFilter, this.currentScreenItem)
      this.showReselectDialog = true
    },
    closeReselectdialog() {
      this.showReselectDialog = false
    },
    updateLiveList(item) {
      console.log('this.screen', item, this.screenFilter.screenNo)
      // this.$parent.handleReselectList(item, this.screenFilter.screenNo, this.currentIndex)
    }
  }
}
</script>

<style lang="scss" scoped>
.class-item {
  width: 100%;
  height: 100%;
  font-size: 12px;
  border-radius: 2px;
  text-align: left;
  font-family:
    PingFangSC-Regular,
    PingFang SC;
  &.active-item {
    border: 2px solid #5f60d3;
    border-radius: 2px;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 0;
      height: 0;
      border: 10px solid;
      border-color: #5f60d3 #5f60d3 transparent transparent;
    }
    .active-icon {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 2;
      font-size: 12px;
      transform: scale(0.9);
      color: #fff;
    }
  }

  .class-title {
    width: 100%;
    height: 20px;
    padding: 0 4px;
    line-height: 20px;
    color: #fff;
    background-color: #00cf96;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .class-info {
    width: 100%;
    height: calc(100% - 20px);
    // min-height: 60px;
    // max-height: 80px;
    padding: 8px 4px 4px;
    background: #f0fff3;
    color: #00cf96;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .classroom {
    width: 100%;
    height: 16px;
    line-height: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .time-and-rechoose {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .choose-btn {
    width: 60px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: #fff;
    cursor: pointer;
  }
}

.class-item-empty {
  width: 100%;
  height: 100%;
  font-size: 14px;
  border-radius: 2px;
  font-family:
    PingFangSC-Regular,
    PingFang SC;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #edf4ff;

  &.active-item {
    border: 2px solid #5f60d3;
    border-radius: 2px;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 0;
      height: 0;
      border: 10px solid;
      border-color: #5f60d3 #5f60d3 transparent transparent;
    }
    .active-icon {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 2;
      font-size: 12px;
      transform: scale(0.9);
      color: #fff;
    }
  }
  .choose-btn {
    width: 60px;
    height: 32px;
    border: 1px solid #5f60d3;
    line-height: 30px;
    background: #fff;
    text-align: center;
    cursor: pointer;
  }
}
</style>
